import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { WineCrudService } from 'src/app/shared/services/wine-crud.service';
import { Wine } from 'src/app/shared/interfaces/wine';
import { Colour } from 'src/app/shared/interfaces/colour';
import { GrapeVariety } from 'src/app/shared/interfaces/grape-variety';
import { GrapeVarietyCrudService } from 'src/app/shared/services/grape-variety-crud.service';
import { ColourCrudService } from 'src/app/shared/services/colour-crud.service';


@Component({
  selector: 'app-wine-current',
  templateUrl: './wine-current.component.html',
  styleUrls: ['./wine-current.component.scss']
})
export class WineCurrentComponent implements OnInit {

  wines: Wine[];
  wine: Wine;
  selectedWines: Wine[] = [];

  grapeVarieties: Partial<GrapeVariety>[];
  grapeVarietyNames: string[];
  grapeVarietiesMap : Map<string,GrapeVariety>;
  colours: Colour[];
  coloursMap : Map<string,Colour>;
  years: number[];

  wineDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private wineService : WineCrudService,
    private grapeVarietyService : GrapeVarietyCrudService,
    private colourService : ColourCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Wines'}
    ];

    this.wines = [];
    this.wine = { } as Wine ;

    this.grapeVarieties = [];
    this.grapeVarietyNames = [];
    this.grapeVarietiesMap = new Map<string,GrapeVariety>();

    this.colours = [];
    this.coloursMap = new Map<string,Colour>();
  
    this.years = [];
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.wineService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.wines = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Wine = jsonItem as Wine;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          if (!l.grapeVarieties) {
            l.grapeVarieties = [];
          } else {
            l.grapeVarieties = Object.values(l.grapeVarieties);
          }
          this.wines.push(l);
        }
      })
    });

    let c = this.colourService.getList(); 
    c.snapshotChanges().subscribe(data => {
      this.colours = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Colour = jsonItem as Colour;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.colours.push(l);
          this.coloursMap.set( l.$key , l);
        }
      })
    });

    let g = this.grapeVarietyService.getList(); 
    g.snapshotChanges().subscribe(data => {
      this.grapeVarieties = [];
      this.grapeVarietyNames = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : GrapeVariety = jsonItem as GrapeVariety;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<GrapeVariety> = l;
          delete ll.$key;
          this.grapeVarieties.push(ll);
          this.grapeVarietyNames.push(l.name);
          this.grapeVarietiesMap.set(l.$key , l);
        }
      });
      console.log(this.grapeVarieties);
    });

    let date : Date = new Date();
    let currentYear : number = date.getFullYear();
    for(let i = currentYear; i > 1800; i-- ) {
        this.years.push(i);
    }

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'colour', header: 'Colour' },
      { field: 'grapeVarieties', header: 'Grape varieties' },
      { field: 'isSparkling', header: 'Sparkling' },
      { field: 'year', header: 'Year' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.wineService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.wines);
            doc.save('wines.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.wines);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "wines");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedWines);
      // console.log('SAVEC CSV LOCATIONS ', this.wines);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedWines, 'wines', exportCols);
   // this.exportService.exportToCsv(this.wines, 'wines', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.wine = {} as Wine;
    this.submitted = false;
    this.wineDialog = true;
  }

  deleteSelectedWines() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected wines?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.wines = this.wines.filter(val => !this.selectedWines.includes(val));
            this.selectedWines = [];
            this.selectedWines.forEach( wine => this.wineService.delete(wine.$key));
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Winess Deleted', life: 3000});
        }
    });
  }

  editWine(wine: Wine) {
    this.wine = {...wine};
    this.wineDialog = true;
  }

  deleteWine(wine: Wine) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + wine.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.wines = this.wines.filter(val => val.$key !== wine.$key);
            this.wine = {} as Wine;
            this.wineService.delete(wine.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wine Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.wineDialog = false;
    this.submitted = false;
  }

  saveWine() {
    this.submitted = true;

    if ( this.wine.name.trim() ) {
      if (this.wine.$key) {
          this.wines[this.findIndexById(this.wine.$key)] = this.wine;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wine Updated', life: 3000});
          this.wineService.update(this.wine);
        } else {
          this.wine.position = this.wines.length;
          this.wineService.add(this.wine);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wine Created', life: 3000});
      this.wines = [...this.wines];
    }

    this.wineDialog = false;
    this.wine = { } as Wine;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.wines.length; i++) {
        if (this.wines[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeWine(wine : Wine) {
    //console.log("SAVE", wine);
    wine.grapeVarieties?.forEach( (g : Partial<GrapeVariety>) => {
      if (g.$key) {
        delete g['$key'];
      }
    });
    this.wineService.update(wine);
  }

  completePosition(wine : Wine) {
   // console.log("SAVE", wine);
  //  this.wineService.updateWine(wine);


    if ( this.newPosition > -1 ) {
        wine.position = this.newPosition;
        wine = this.checkPositionLimits(wine);
        this.reorderElements(wine);
        //this.updateDB(wine);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.wines);
    // const myClonedArray = [];
    // this.wines.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.wines.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.wines.length - 1 - event.dropIndex;
    const wineToMove = this.wines[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.wines[index] = this.wines[index+1];
        this.wines[index].position = index;
        this.wineService.update(this.wines[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.wines[index] = this.wines[index-1];
        this.wines[index].position = index;
        this.wineService.update(this.wines[index]);
      }
    } 
    this.wines[endIndex] = wineToMove;
    this.wines[endIndex].position = endIndex;
    this.wineService.update(this.wines[endIndex]);
  }

  // onFieldEdit(wine: Spray, fieldName: string): void {
  //   //console.log(this.wines);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + wine[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       wine.position = this.newPosition;
  //       wine = this.checkPositionLimits(wine);
  //       this.reorderElements(wine);
  //       //this.updateDB(wine);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(wine);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.wines.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, wine: Wine) {
    // console.log("event" +event);
    if (wine.position != null && wine.position > -1) {
      this.previousPosition = wine.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(wine: Wine) {
    console.log('check ',wine.position + ' ' + this.wines.length);
    if (!wine.position) {
     // console.log('check 1');
      return this.wine;
    }
    if (wine.position < 0) {
      wine.position = 0;
      // console.log('check 2');
      return wine;
    }
    if (wine.position > this.wines.length) {
      wine.position = this.wines.length - 1;
    //  console.log('check 3', wine.position);
      return wine;
    }
   // console.log('check 4');
    return wine;
  }

  async reorderElements(wine: Wine) {
    this.newPosition = this.newPosition  > this.wines.length ? this.wines.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === wine.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const wineToMove = this.wines[startIndex];
   // console.log('Item to move: ', this.wines[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.wines);
        console.log('Item to +1: ', this.wines[index+1]);

        this.wines[index] = this.wines[index+1];
        this.wines[index].position = index;
        // console.log('Move: ', this.wines[index+1]);
        // console.log('Move pos: ', this.wines[index].position);
        //await this.updateDB(this.wines[index]);
        this.wineService.update(this.wines[index]);
     //   console.log('Update DB: ', this.wines[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.wines[index] = this.wines[index-1];
        this.wines[index].position = index;
        this.wineService.update(this.wines[index]);
      }
    } 
    this.wines[endIndex] = wineToMove;
    this.wines[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.wineService.update(this.wines[endIndex]);
    
    // const myClonedArray = [];
    // this.wines.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.wines = myClonedArray;
   // this.getAllRecords();
  }

  onOptionClick(event: any, wine : Wine) {
    console.log( event );
    console.log( wine.grapeVarietyNames );

    wine.grapeVarietyNames = [];
    event.value.forEach( (record : GrapeVariety) => {
      wine.grapeVarietyNames?.push(record.name);
    } );

    console.log( wine.grapeVarietyNames );
    console.log( wine);
    this.completeWine(wine);
    // if (this.value && this.value.length) { // Check if this.value is not null or undefined, and if it has a length property
    //   // Do the iteration over this.value here
    // }
 
  }
}